import $ from 'jquery';
import _ from "lodash";

class Draw {
    constructor(selector) {
        const $el = $(selector);
        const $canvas = $el.find('canvas');

        const canvas = $canvas[0];
        const context = canvas.getContext('2d');

        canvas.width = $el.width();
        canvas.height = $el.height();

        let lastX = 0;
        let lastY = 0;
        let isDrawing = false;

        $(window).resize(_.debounce(() => {
            canvas.width = $el.width();
            canvas.height = $el.height();
            lastX = 0;
            lastY = 0;
            isDrawing = false;
        }, 100));

        canvas.ontouchstart = function (e) {
            const rect = e.target.getBoundingClientRect();
            const mouseX = e.targetTouches[0].pageX - rect.left;
            const mouseY = e.targetTouches[0].pageY - rect.top;
            lastX = mouseX;
            lastY = mouseY;
            isDrawing = true;
        };

        canvas.onmousedown = function (e) {
            let mouseX = e.offsetX;
            let mouseY = e.offsetY;
            lastX = mouseX;
            lastY = mouseY;
            isDrawing = true;
        };

        canvas.onmousemove = function (e) {
            if (!e) {
                e = event;
            }

            if (!isDrawing) {
                return;
            }

            let mouseX = e.offsetX;
            let mouseY = e.offsetY;
            context.moveTo(lastX, lastY);
            context.lineTo(mouseX, mouseY);
            context.strokeStyle = "#0000000";
            context.closePath();
            context.stroke();

            lastX = mouseX;
            lastY = mouseY;
        };

        canvas.ontouchmove = function (e) {
            if (!isDrawing) {
                return;
            }

            if (!e) {
                e = event;
            }

            const rect = e.target.getBoundingClientRect();
            const mouseX = e.targetTouches[0].pageX - rect.left;
            const mouseY = e.targetTouches[0].pageY - rect.top;

            context.moveTo(lastX, lastY);
            context.lineTo(mouseX, mouseY);
            context.strokeStyle = "#0000000";

            context.closePath();
            context.stroke();

            lastX = mouseX;
            lastY = mouseY;

            e.preventDefault();
        };

        document.onmouseup = function (e) {
            isDrawing = false;
        };

        document.ontouchend = function (e) {
            isDrawing = false;
        };
    }
}

module.exports = Draw;











// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/draw.js